// extracted by mini-css-extract-plugin
export default {"language":"changeLangButtons_language__Z3nRK","baldLang":"changeLangButtons_baldLang__i6mR7","langs":"changeLangButtons_langs__JjDL6"};